<template>
  <div id="map-picker" style="z-index:1"></div>
</template>

<script>
import * as L from "leaflet";

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    zoom: {
      type: Number,
      required: false,
      default: 2
    },
    center: {
      type: L.LatLng,
      required: false,
      default: function() {
        return new L.LatLng(51.9805067, 9.2803464);
      }
    },
    height: {
      type: String,
      required: false,
      default: "200px"
    },
    width: {
      type: String,
      required: false,
      default: "100%"
    },
    tileLayerUrl: {
      type: String,
      default: "https://{s}.tile.osm.org/{z}/{x}/{y}.png"
    },  
    attribution: {
      type: String,
      default: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      map: null,
      location: undefined,
      centerMarker: null,
    };
  },
  async mounted() {
    var that = this;

    document.getElementById("map-picker").style.height = this.height;
    document.getElementById("map-picker").style.width = this.width;

    if (this.map != null) return;

    this.map = L.map("map-picker", {
      //zoomControl: false,
      center: this.center,
      zoom: this.zoom,
      scrollWheelZoom: false
    });
    L.tileLayer(this.tileLayerUrl, { attribution: this.attribution }).addTo(
      this.map
    );

    
    this.centerMarker = L.circle(this.value, {
          color: "red",
          fillColor: "#f03",
          fillOpacity: 0.5,
          radius: 10
        }).addTo(this.map);
        this.centerMarker.bindTooltip("Center Location");
      

    this.map.on("click", function(clickEvent) {
      if(that.disabled) return;

      let element = clickEvent.latlng;
      element.lat = element.lat.toFixed(7);
      element.lng = element.lng.toFixed(7);
      that.location = { lat: element.lat, lng: element.lng };
      that.$emit("input", that.location)

      if (that.centerMarker != null) {
        that.centerMarker.setLatLng(that.location);
      } else {
        that.centerMarker = L.circle(that.location, {
          color: "red",
          fillColor: "#f03",
          fillOpacity: 0.5,
          radius: 10
        }).addTo(that.map);
        that.centerMarker.bindTooltip("Center Location");
      }
      that.map.setView(that.location, that.zoom, {
        pan: { animate: true, duration: 1.5 }
      });
    });

    setTimeout(function() {
      that.map.invalidateSize();
    }, 500);
 
    
  },
  methods: {
    updateMap() {
      if (this.centerMarker != null) {
        this.centerMarker.setLatLng(this.value);
      } else {
        this.centerMarker = L.circle(this.value, {
          color: "red",
          fillColor: "#f03",
          fillOpacity: 0.5,
          radius: 10
        }).addTo(this.map);
        this.centerMarker.bindTooltip("Center Location");
      }
      this.map.setView(this.value, this.zoom, {
        pan: { animate: true, duration: 1.5 }
      });
    }
  },
  watch: {
    value: function() {
      this.updateMap()
    },
    zoom: function() {
      this.map.setView(this.value, this.zoom, {
        pan: { animate: true, duration: 1.5 }
      });
    }
  }
};
</script>
